import loadProposalActions from './actions';
import documentsActions from './documentActions';

export default {
    ...loadProposalActions,
    ...documentsActions,
};
